
function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

const timelineElementsNotVisible = document.querySelectorAll('.timeline.not-visible');
const timelineElementsVisibleFirst = document.querySelector('.timeline.visible');
const loadMoreButton = document.querySelector('.load-more-js') as HTMLButtonElement;

function showTimelineElementsFirstBoth() {
    const timelineElementsVisible = document.querySelectorAll('.timeline.visible');
    if (isElementInViewport(timelineElementsVisibleFirst)) {
        timelineElementsVisible.forEach(element => {
            const firstChild = element.firstElementChild as HTMLElement;
            firstChild.style.opacity = '1';
            firstChild.style.transform = 'translateY(0)';
        });
    }
}
if (timelineElementsVisibleFirst) {
    window.addEventListener('scroll', showTimelineElementsFirstBoth);
}

if (timelineElementsNotVisible.length > 0 && loadMoreButton) {

    let countTimelineElements = 2;

    function showTimelineElements() {
        for (let i = 0; i < countTimelineElements; i++) {
            if (timelineElementsNotVisible[i]) {
                timelineElementsNotVisible[i].classList.remove('not-visible');
                timelineElementsNotVisible[i].classList.add('visible');
                setTimeout(() => {
                    const firstChild = timelineElementsNotVisible[i]?.firstElementChild as HTMLElement;
                    firstChild.style.opacity = '1';
                    firstChild.style.transform = 'translateY(0)';
                }, 200);
            }
        }
        countTimelineElements += 2;
        if (countTimelineElements >= timelineElementsNotVisible.length) {
            loadMoreButton.style.display = 'none';
        }
    }
    loadMoreButton.addEventListener('click', showTimelineElements);
}